import React from "react";

import * as MarketplaceAPI from "api/MarketplaceDemoAPI";
import * as BlueprintAPI from "api/BlueprintAPI";
import * as marketplaceDemoReducer from "containers/MarketplaceDemo/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";

const UPDATE_FIELD = "consultingProjects/UPDATE_FIELD";

const initialState = {
  projectID: null,
  projectData: [],
  creatingProject: false
};

export const PROGRESS_STAGES = {
  pendingAcceptance: "pending",
  inProgress: "in progress",
  complete: "complete",
  inDispute: "in dispute"
};

function consultingProjectsReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: action.data
      };
    default:
      return state;
  }
}

/* Selectors */
export function getConsultingProjects(state) {
  return state.consultingProjects;
}

export function getProjectID(state) {
  return getConsultingProjects(state).projectID;
}

export function getProjectData(state) {
  return getConsultingProjects(state).projectData;
}

export function getProjectDatasets(state) {
  return (
    getProjectData(state) &&
    getProjectData(state)
      .map((id) => homeReducer.getDataset(state, id))
      .filter((dataset) => dataset && dataset.deleted !== true)
  );
}

export function getCreatingProject(state) {
  return getConsultingProjects(state).creatingProject;
}

/* Actions */
export function updateProjectID(projectID) {
  return { type: UPDATE_FIELD, data: projectID, key: "projectID" };
}

export function updateProjectData(datasets) {
  return { type: UPDATE_FIELD, data: datasets, key: "projectData" };
}

export function updateCreatingProject(val = false) {
  return { type: UPDATE_FIELD, data: val, key: "creatingProject" };
}

/* Methods */
export function init() {
  return (dispatch, getState) => {
    dispatch(marketplaceDemoReducer.fetchBlueprints());
    dispatch(marketplaceDemoReducer.fetchData());
    dispatch(marketplaceDemoReducer.fetchConsulting());
  };
}

export function clearProject() {
  return (dispatch, getState) => {
    if (getProjectID(getState()) !== null) {
      dispatch(updateProjectID(null));
      dispatch(updateProjectData([]));
      dispatch(updateCreatingProject(false));
    }
  };
}

export function selectProject(id) {
  return (dispatch, getState) => {
    const consulting = marketplaceDemoReducer.getBPConsultingPost(getState(), parseInt(id));
    if (consulting && consulting.wizard && consulting.wizard.project) {
      dispatch(updateProjectID(parseInt(id)));
      const linkedData = consulting.wizard.project.links && consulting.wizard.project.links.data;
      linkedData && dispatch(updateProjectData(linkedData.map((elem) => elem.id)));
    }
  };
}

export function cancelConsultingProject(id) {
  return (dispatch, getState) => {
    const consulting = marketplaceDemoReducer.getBPConsulting(getState())[parseInt(id)];
    const wizard = consulting && consulting.wizard;
    wizard.marketplace.purchased = false;
    delete wizard.project;
    return BlueprintAPI.updateBlueprint(id, wizard).then((response) => {
      const bpConsulting = marketplaceDemoReducer.getBPConsulting(getState());
      bpConsulting[response.id] = response;
      dispatch(marketplaceDemoReducer.updateBPConsulting(bpConsulting));
      return dispatch(marketplaceDemoReducer.fetchConsulting());
    });
  };
}

export function progressConsultingProject(id, newStatus) {
  return (dispatch, getState) => {
    const consulting = marketplaceDemoReducer.getBPConsulting(getState())[parseInt(id)];
    const wizard = consulting && consulting.wizard;
    wizard.project.status = newStatus;
    return BlueprintAPI.updateBlueprint(id, wizard).then((response) => {
      const bpConsulting = marketplaceDemoReducer.getBPConsulting(getState());
      bpConsulting[response.id] = response;
      dispatch(marketplaceDemoReducer.updateBPConsulting(bpConsulting));
      return dispatch(marketplaceDemoReducer.fetchConsulting());
    });
  };
}

export function getProcessingDatasets(state) {
  return getProjectDatasets(state).filter(
    (dataset) =>
      dataset.rowCount === -1 &&
      dataset.errors.length === 0 &&
      dataset.status &&
      dataset.status.indexOf("missing_target_variable") === -1
  );
}

export function getConsultingDatasets() {
  return (dispatch, getState) => {
    const datasets = getProcessingDatasets(getState());

    for (const dataset of datasets) {
      DatasetAPI.getDataset(dataset.id).then((response) => {
        return dispatch(homeReducer.updateDataset(response.id, homeReducer.transformDataset(response)));
      });
    }
  };
}

export function getBlueprintDataset(id) {
  return (dispatch, getState) => {
    return blueprintReducer.getOriginalDataset(getState(), id);
  };
}

export default consultingProjectsReducer;
